<template>
  <div v-if="answerVisible">
    <el-dialog
      title="网络直播课效果在线答题"
      :visible.sync="testVisible"
      width="800px"
      class="answerView"
      :close-on-click-modal="false"
      center
      :before-close="handleClose">
      <div class="answerData">
        <div class="title">{{answerCurrent.stTitle}}</div>
        <el-radio-group class="option" v-if="answerCurrent.stQuestiontype == 0" v-model="checkList[answerCurrent.stId]">
          <el-radio v-if="answerCurrent.stOp1" label="A">{{answerCurrent.stOp1}}</el-radio>
          <el-radio v-if="answerCurrent.stOp2" label="B">{{answerCurrent.stOp2}}</el-radio>
          <el-radio v-if="answerCurrent.stOp3" label="C">{{answerCurrent.stOp3}}</el-radio>
          <el-radio v-if="answerCurrent.stOp4" label="D">{{answerCurrent.stOp4}}</el-radio>
          <el-radio v-if="answerCurrent.stOp5" label="E">{{answerCurrent.stOp5}}</el-radio>
        </el-radio-group>
        <el-checkbox-group class="option" v-if="answerCurrent.stQuestiontype == 1" v-model="checkList[answerCurrent.stId]">
          <el-checkbox v-if="answerCurrent.stOp1" label="A" name="type">{{answerCurrent.stOp1}}</el-checkbox>
          <el-checkbox v-if="answerCurrent.stOp2" label="B" name="type">{{answerCurrent.stOp2}}</el-checkbox>
          <el-checkbox v-if="answerCurrent.stOp3" label="C" name="type">{{answerCurrent.stOp3}}</el-checkbox>
          <el-checkbox v-if="answerCurrent.stOp4" label="D" name="type">{{answerCurrent.stOp4}}</el-checkbox>
          <el-checkbox v-if="answerCurrent.stOp5" label="E" name="type">{{answerCurrent.stOp5}}</el-checkbox>
        </el-checkbox-group>
        <el-radio-group class="option" v-if="answerCurrent.stQuestiontype == 2" v-model="checkList[answerCurrent.stId]">
          <el-radio label="A">正确</el-radio>
          <el-radio label="B">错误</el-radio>
        </el-radio-group>
      </div>
      <div v-if="rightKeyShow" class="rightKey">正确答案：{{answerCurrent.stResult}}</div>
      <span slot="footer" class="dialog-footer">
        <span class="answerTime">{{userTime}}</span>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" v-if="currentNum < answerData.length-1" @click="nextAnswer(answerCurrent)">下一题</el-button>
        <el-button type="primary" v-if="currentNum == answerData.length-1" @click="onSubmit(answerCurrent)">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="hasAnswerVisible"
      width="30%"
      :before-close="handleCloseTips">
      <span>当前课时没有课题，请联系管理员维护</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCloseTips">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'answerView',
  props: ['type', 'answerId', 'olCurriculumId', 'checkCode'],
  computed: {
    ...mapState(['answerVisible'])
  },
  data () {
    return {
      answerData: [],
      checkList: {},
      hasAnswerVisible: false,
      testVisible: false,
      // 判断是否答过题 0未答 1已答
      stStatue: 0,
      answerCurrent: {},  // 当前答题
      currentNum: 0,    // 当前答题下标
      trueNum: 0,      // 答对次数
      answerArr: [],
      userTime: 0,
      setIntervalShow: false,
      rightKeyShow: false  // 正确答案显示
    }
  },
  mounted () {
    // console.log(this.type)
    // console.log('this.answerId + ' + this.answerId)
    this.getQuestions(this.type, this.answerId)
  },
  methods: {
    ...mapMutations(['setAnswerVisible', 'setPlayVisible']),
    getQuestions (type, id) {
      let that = this

      let url = ''
      let data = ''
      if (Number(type) === 3) {
        //  课时对应答题接口
        url = '/api/renren-fast/app/olcurriculumstagemxst/list'
        data = {olMxId: id, olCurriculumId: this.olCurriculumId}
      } else if (Number(type) === 2) {
        //  阶段对应答题接口
        url = '/api/renren-fast/app/olcurriculumstagest/list'
        data = {olCurriculumStage: id}
      }
      this.$http({
        method: 'get',
        url: url,
        params: data
      }).then((result) => {
        if (result.data.code === 0) {
          that.stStatue = result.data.data.stStute
          if (result.data.data.stData.list && result.data.data.stData.list.length > 0) {
            that.testVisible = true
            that.answerData = result.data.data.stData.list
            that.answerCurrent = that.answerData[0]
            that.setTime()
          } else {
            that.hasAnswerVisible = true
          }
          that.answerData.map((item, key) => {
            if (result.data.data.stStute === 1) {
              // 单选题 或 判断题
              if (Number(item.stQuestiontype) === 0 || Number(item.stQuestiontype) === 2) {
                that.$set(that.checkList, item.stId, item.stResult)
              }
              // 多选题
              if (Number(item.stQuestiontype) === 1) {
                let arr = item.stResult.split('')
                that.$set(that.checkList, item.stId, arr)
              }
            } else {
              // 单选题 或 判断题
              if (Number(item.stQuestiontype) === 0 || Number(item.stQuestiontype) === 2) {
                that.$set(that.checkList, item.stId, '')
              }
              // 多选题
              if (Number(item.stQuestiontype) === 1) {
                that.$set(that.checkList, item.stId, [])
              }
            }
          })
        } else {
          that.$message.error(result.data.msg)
          that.handleClose()
        }
      })
    },
    handleClose () {
      let that = this
      clearInterval(this.setIntervalShow)
      that.setAnswerVisible(false)
      that.setPlayVisible(false)
    },
    setTime() {
      let that = this
      if (this.setIntervalShow) {
        clearInterval(this.setIntervalShow)
      }
      this.setIntervalShow = setInterval(function () {
        that.userTime++
      }, 1000)
    },
    // 下一题
    nextAnswer(val) {
      let that = this
      if (this.checkList[val.stId] == '') {
        this.$message.error('请做出回答')
      } else {
        this.answerJudge(val, this.userTime)
      }
    },
    // 答题数据变更
    changeAnswer() {
      this.currentNum++
      this.answerCurrent = this.answerData[this.currentNum]
      this.userTime = 0
      this.setTime()
    },
    answerJudge(val, time) {
      let that = this
      //  判断是否正确 0 错误 1 正确
      let stResult = 0
      let checkID = ''
      if (val.stQuestiontype != 1) {
        if (that.checkList[val.stId].toUpperCase() === val.stResult.toUpperCase()) {
          stResult = 1
          that.trueNum += 1
        }
      } else {
        let arr = that.checkList[val.stId].sort()
        arr.map((item, key) =>{
          checkID = checkID + item.toUpperCase()
        })
        if (checkID == val.stResult.toUpperCase()) {
          stResult = 1
          that.trueNum += 1
        }
      }

      let data = {
        // 试题对应类型ID
        'oId': this.answerId,
        // 类型（1课程，2阶段，3课时）
        'type': this.type,
        // 试题ID
        'stId': val.stId,
        'result': val.stQuestiontype != 1 ? that.checkList[val.stId] : checkID,
        'olTrue': stResult,
        'useTime': time,
        'nId': this.checkCode
      }
      that.answerArr.push(data)

      if (stResult == 0) {
        that.rightKeyShow = true
        setTimeout(function () {
          that.changeAnswer()
          that.rightKeyShow = false
        }, 1500)
      } else {
        that.changeAnswer()
      }
    },
    onSubmit (val) {
      let that = this
      if (this.checkList[val.stId] == '') {
        this.$message.error('请做出回答')
        return
      }
      that.answerJudge(val, this.userTime)
      if (this.setIntervalShow) {
        clearInterval(this.setIntervalShow)
      }
      that.answerType(that.trueNum)
    },
    answerType (trueNum) {
      let that = this
      let scale = trueNum / that.answerData.length
      if (scale >= 0.6 && that.answerData.length !== 0) {
        if (that.stStatue === 0) {
          this.$http({
            method: 'POST',
            url: '/api/renren-fast/app/strecord/savelist',
            data: that.answerArr
          })
        }
        this.$message({
          message: '恭喜你，答题成功',
          type: 'success'
        })
        that.setAnswerVisible(false)
        that.setPlayVisible(false)
      } else {
        if (that.answerData.length === 0) {
          this.$message.error('当前课时没有课题，请联系管理员维护')
        } else {
          this.$message.error('答题失败，再接再励哦')
        }
      }
    },
    handleCloseTips () {
      let that = this
      that.hasAnswerVisible = false
      that.setAnswerVisible(false)
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.answerView{
  .answerData{
    max-height: 400px;
    overflow-y: auto;
    .title{
      margin-bottom: 10px;
    }
    .option{
      margin-bottom: 15px;
    }
  }
  .el-dialog__footer{
    width: 100%;
    text-align: center;
  }
  .answerTime{
    margin-right: 20px;
  }
  .rightKey{
    color: #dc5858;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answerView.vue